import { Button, Link, Paper, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { getBackendTypstUrl } from "../../../redux/common";
import { SchoolInfo } from "../../../redux/school/schoolSlice";
import { StudentInfo } from "../../../redux/student/studentSlice";

interface StudentInviteReportProps {
    school: SchoolInfo;
    student: StudentInfo;
}

const StudentInviteReport = (props: StudentInviteReportProps) => {
    const dispatch = useDispatch();
    const { school, student } = props;

    return (
        <center>
            <Paper style={{ padding: 20, margin: 20, minWidth: 300, maxWidth: 600, boxSizing: "border-box" }}>
                <Typography style={{ marginTop: 10 }}>
                    Este relatório gera um PDF com o convite para o aluno, contendo o código do convite e o nome do aluno, além de informações sobre o aplicativo, que pode ser impresso para ser enviado à família.
                </Typography><br />
                <Link href={`${getBackendTypstUrl()}/api/invite/student/${student.id}`}
                    target="_blank" rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}>
                    <Button variant="contained" color="primary">Gerar relatório</Button>
                </Link>
            </Paper>
        </center>
    );
};

export default StudentInviteReport;